import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
    ClientManagerInstanceToken,
    ClientManagerInterface,
    ConfigService,
    EnvironmentPathUtilitiesService,
    NotificationInterface,
    OnlineOnlyService,
    SynchronizationInstanceToken,
    SynchronizationInterface,
    SyncQueueService,
    UriUtilitiesService,
    UserMasterService,
    WindowService,
} from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Observable } from 'rxjs';
import { NotificationInstanceToken } from '../core/interfaces/notification.interface';
import { FormsWriteWithPaceOfflineService } from './forms-write-with-pace-offline.mock.service';
import { FormsWriteInterface, ODataReleaseLockPayload, ODataSubmitFormPayload } from './forms-write.interface';
import { XmlParserService } from './xml-parser.service';
import { XmlSerializerService } from './xml-serializer.service';

@Injectable({
    providedIn: 'root',
})
export class FormsWriteOnlineOnlyService extends FormsWriteWithPaceOfflineService implements FormsWriteInterface {
    public constructor(
        http: HttpClient,
        @Inject(LogInstanceToken) log: LogInterface,
        window: WindowService,
        configService: ConfigService,
        @Inject(SynchronizationInstanceToken) synchronizationService: SynchronizationInterface,
        @Inject(NotificationInstanceToken) notificationService: NotificationInterface,
        @Inject(ClientManagerInstanceToken) clientManager: ClientManagerInterface,
        userMasterService: UserMasterService,
        syncQueueService: SyncQueueService,
        xmlParserService: XmlParserService,
        xmlSerializerSerice: XmlSerializerService,
        uriUtilities: UriUtilitiesService,
        environmentPathUtilities: EnvironmentPathUtilitiesService,
        onlineOnlyService: OnlineOnlyService,
    ) {
        super(
            http,
            log,
            window,
            configService,
            synchronizationService,
            notificationService,
            clientManager,
            userMasterService,
            syncQueueService,
            xmlParserService,
            xmlSerializerSerice,
            uriUtilities,
            environmentPathUtilities,
            onlineOnlyService,
        );
    }

    protected postRequest(url: string, payload: ODataSubmitFormPayload | ODataReleaseLockPayload): Observable<unknown> {
        return this.onlineOnlyService.post(url, payload);
    }
}
